class HeaderScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 50
    this.safeZone = 150
    this.returnToTopThreshold = window.innerHeight

    this.setScrolled()
    this.setColour()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll.bind(this), {
      passive: true,
    })

    this.listeners.add(window, 'resize', () => {
      this.returnToTopThreshold = window.innerHeight
      this.setReturnToTopState()
    })

    this.listeners.add(document, 'click', this.handleTopClick.bind(this))
  }

  handleTopClick (e) {
    if (!e.target.closest('[data-header-scroll-external-el="top"]')) return

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown <= this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
    this.updateScrollState()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setScrolled()
    this.setScrollDirection()
    this.setReturnToTopState()
    this.setColour()
  }

  updateScrollState () {
    clearTimeout(this.scrollTimeout)

    this.scrollTimeout = setTimeout(() => {
      this.setScrolled()
    }, 250)
  }

  setScrolled () {
    const isScrolled = window.scrollY > 0

    document.body.classList.toggle('lyt-Theme-scrolled', isScrolled)
  }

  setScrollDirection () {
    const isScrollingUp = this.scrollDirection === 'up'

    document.body.classList.toggle('lyt-Theme-scrollUp', isScrollingUp)
  }

  setReturnToTopState () {
    const hasScrolledPastThreshold =
      this.lastKnownY >= this.returnToTopThreshold

    document.body.classList.toggle(
      'lyt-Theme-returnToTop',
      hasScrolledPastThreshold,
    )
  }

  setColour () {
    if (!this?.externalEls?.section?.exists) return

    this.setHeaderColour()

    if (!this?.externalEls?.['floating-navigation']?.exists) return

    this.setFloatingNavColour()
  }

  setFloatingNavColour () {
    const floatingNav = this.externalEls[
      'floating-navigation'
    ].element.getBoundingClientRect()

    this.externalEls.section.elements.some(sectionEl => {
      const section = sectionEl.getBoundingClientRect()
      if (
        section.top <= floatingNav.top &&
        section.top + section.height > floatingNav.top
      ) {
        this.navigationColour = `${sectionEl.dataset.navigationColour}`

        document.documentElement.style.setProperty(
          '--Nav_Color',
          this.navigationColour,
        )

        return true
      }

      document.documentElement.style.setProperty(
        '--Nav_Color',
        this.defaultColour,
      )

      return false
    })
  }

  setHeaderColour () {
    const header = this.getBoundingClientRect()

    this.externalEls.section.elements.some(sectionEl => {
      const section = sectionEl.getBoundingClientRect()
      if (
        section.top <= header.top &&
        section.top + section.height > header.top
      ) {
        this.navigationColour = `${sectionEl.dataset.navigationColour}`

        document.documentElement.style.setProperty(
          '--Header_Color',
          this.navigationColour,
        )

        return true
      }

      document.documentElement.style.setProperty(
        '--Header_Color',
        this.defaultColour,
      )

      return false
    })
  }

  get defaultColour () {
    return 'var(--Color_Brand)'
  }

  get isScrolled () {
    return this.lastKnownY >= this.safeZone
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }
}

if (!customElements.get('header-scroll')) {
  customElements.define('header-scroll', HeaderScroll)
}
